import { PIN_LENGTH } from '../../shared/constants.js';

/** How the receiver identifies the transfer it wants to join. */
export type JoinTarget = Readonly<{ kind: 'room'; roomId: string }> | Readonly<{ kind: 'pin'; pin: string }>;

export type Route =
  | Readonly<{ kind: 'send' }>
  | Readonly<{ kind: 'receive'; target: JoinTarget }>
  /** Owner console of a permanent inbox. */
  | Readonly<{ kind: 'inbox' }>
  /** Customer sending a file to a permanent inbox. */
  | Readonly<{ kind: 'send-to-inbox'; inbox: string }>
  | Readonly<{ kind: 'not-found' }>;

const PIN_ROUTE = new RegExp(`^/p/([0-9]{${PIN_LENGTH}})/?$`);
const INBOX_TARGET_ROUTE = new RegExp(`^/to/([0-9]{${PIN_LENGTH}})/?$`);

export const parseRoute = (pathname: string): Route => {
  if (pathname === '/' || pathname === '') {
    return { kind: 'send' };
  }
  const room = /^\/r\/([a-z0-9]+)\/?$/.exec(pathname);
  if (room !== null && room[1] !== undefined) {
    return { kind: 'receive', target: { kind: 'room', roomId: room[1] } };
  }
  const pin = PIN_ROUTE.exec(pathname);
  if (pin !== null && pin[1] !== undefined) {
    return { kind: 'receive', target: { kind: 'pin', pin: pin[1] } };
  }
  if (pathname === '/inbox' || pathname === '/inbox/') {
    return { kind: 'inbox' };
  }
  const inbox = INBOX_TARGET_ROUTE.exec(pathname);
  if (inbox !== null && inbox[1] !== undefined) {
    return { kind: 'send-to-inbox', inbox: inbox[1] };
  }
  return { kind: 'not-found' };
};

export const buildShareLink = (origin: string, roomId: string): string => `${origin}/r/${roomId}`;

export const buildPinPath = (pin: string): string => `/p/${pin}`;

export const buildInboxPath = (inbox: string): string => `/to/${inbox}`;

export const buildInboxLink = (origin: string, inbox: string): string => `${origin}${buildInboxPath(inbox)}`;
